import * as tslib_1 from "tslib";
import { BaseComponent } from "@impacgroup/angular-baselib";
var CategoriesMainComponent = /** @class */ (function (_super) {
    tslib_1.__extends(CategoriesMainComponent, _super);
    function CategoriesMainComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CategoriesMainComponent;
}(BaseComponent));
export { CategoriesMainComponent };
